import { HttpClient, HttpEvent } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EnvironmentService } from '../../../../environments/environment.service';

@Injectable({
  providedIn: 'root',
})
export class QundisImportService {
  /** AWS API Gateway rejects larger payloads before the request reaches the parser. */
  public static readonly MAX_FILE_SIZE_BYTES = 10_000_000;

  private readonly http = inject(HttpClient);

  private readonly uploadUrl = `${inject(EnvironmentService).mbusParserService}/els-upload-file`;

  uploadElsFile(file: File): Observable<HttpEvent<unknown>> {
    const formData = new FormData();
    formData.append('file', file);

    return this.http.post(this.uploadUrl, formData, { reportProgress: true, observe: 'events' });
  }
}
